export const ellipsisHeaderOptions = [
  { label: 'Import Contracts', value: 'Import Contracts', callback: 'onClickHistory' },
  { label: 'Batch Processing', value: 'Batch Processing', callback: 'onClickHistory' },
  { label: 'Add Contract', value: 'Add Contracts', callback: 'onClickHistory' }
];
export const ellipsisOptions = [
  { label: 'Edit', value: 'Edit', callback: 'onRowEdit' },
  { label: 'Delete ', value: 'Delete', callback: 'onRowDelete' }
];
